import { api } from '@/services/api/AxiosBaseService'

/** Item de documento normalizado para o componente DocumentsManager. */
export interface DocItem {
  id: string
  name: string
  url: string | null
  size?: number | null
  createdAt?: string | null
  signedAt?: string | null
}

/** Contrato que o DocumentsManager consome — abstrai a entidade dona. */
export interface DocService {
  list(): Promise<DocItem[]>
  upload(file: File, extra?: { signedAt?: string }): Promise<void>
  remove(id: string): Promise<void>
  /** Quando true, o componente exibe o campo "data de assinatura" no upload. */
  hasSignedDate?: boolean
}

interface RawDoc {
  id: string
  name: string
  mime?: string | null
  size?: number | null
  url: string | null
  createdAt?: string | null
}

/**
 * Documentos padrão (Empresas, Usuários, Associados) — mesma forma de payload.
 * `basePath` ex.: `/commercial/companies/123`, `/administractive/users/123`.
 */
export function standardDocuments(basePath: string): DocService {
  const base = `${basePath}/documents`
  return {
    async list() {
      const r = await api.get<{ data: RawDoc[] }>(base)
      return r.data.data.map((d) => ({
        id: d.id, name: d.name, url: d.url, size: d.size ?? null, createdAt: d.createdAt ?? null,
      }))
    },
    async upload(file) {
      const fd = new FormData()
      fd.append('file', file)
      await api.post(base, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    },
    async remove(id) {
      await api.delete(`${base}/${id}`)
    },
  }
}

interface RawContract {
  id: string
  fileName: string | null
  contractUrl: string | null
  contractSignedAt: string | null
  createdAt: string | null
}

/** Contratos do credenciado (forma específica: contract_file + data de assinatura). */
export function providerContracts(providerId: string): DocService {
  const base = `/credentialing/providers/${providerId}/contracts`
  return {
    hasSignedDate: true,
    async list() {
      const r = await api.get<{ data: RawContract[] }>(base)
      return r.data.data.map((c) => ({
        id: c.id,
        name: c.fileName ?? 'Contrato',
        url: c.contractUrl,
        signedAt: c.contractSignedAt,
        createdAt: c.createdAt,
      }))
    },
    async upload(file, extra) {
      const fd = new FormData()
      fd.append('contract_file', file)
      if (extra?.signedAt) fd.append('contract_signed_at', extra.signedAt)
      await api.post(base, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    },
    async remove(id) {
      await api.delete(`${base}/${id}`)
    },
  }
}
